<template>
  <b-navbar
    id="base-header"
    class="base-header sticky-top w-100 align-items-center"
    :class="navbarClasses"
  >
    <a
      v-if="
        (leftArrow || leftText || leftIcon) &&
        (mode === 'secondary' || mode === 'light')
      "
      href="#"
      class="btn-left position-absolute h-100 d-block text-white d-flex align-items-center justify-content-center position-relative"
      @click.prevent="onClickLeft"
    >
      <div v-if="leftText" class="left-text text-16">{{ $t(leftText) }}</div>
      <i
        v-else-if="leftIcon"
        class="left-icon text-32"
        :class="`icon-${leftIcon}`"
      ></i>
      <i v-else class="left-icon text-32 icon-Chevron-left"></i>
    </a>
    <div v-if="hasLogo">
      <img
        class="img-logo"
        :src="require('@/assets/img/logo-white-transparent.svg')"
      />
    </div>
    <h4
      v-else
      class="base-header-title d-flex align-items-center"
      :class="[
        [
          {'font-weight-bold': isTitleBold || mode === 'primary'},
          mode === 'primary' ? 'text-20' : 'text-18',
        ],
      ]"
    >
      <template v-if="breadcrumb.length !== 0 && mode === 'primary'">
        <template v-if="breadcrumb.length > 3">
          <div class="breadcrumb-container d-flex align-items-center">
            <span
              class="bread-title font-weight-bold clickable"
              style="color: #606266"
              @click="onClickBread(breadcrumb[0])"
              >{{ $t(breadcrumb[0].name) }}</span
            >
            <i class="icon-Chevron-right"></i>
          </div>
          <div class="breadcrumb-container d-flex align-items-center">
            <b-dropdown
              no-caret
              variant="link"
              class="breadcrumb-ellipsis-dropdown"
            >
              <template #button-content>
                <span
                  class="bread-title font-weight-bold"
                  style="color: #606266"
                  >...</span
                >
              </template>
              <b-dropdown-item
                v-for="bread in breadcrumb.slice(1, breadcrumb.length - 1)"
                :key="bread.router || bread.name"
                @click="onClickBread(bread)"
                >{{ $t(bread.name) }}</b-dropdown-item
              >
            </b-dropdown>
            <i class="icon-Chevron-right"></i>
          </div>
          <div class="breadcrumb-container d-flex align-items-center">
            <span
              class="bread-title font-weight-bold"
              style="color: #303133; pointer-events: none"
              >{{ $t(breadcrumb[breadcrumb.length - 1].name) }}</span
            >
          </div>
        </template>
        <template v-else>
          <div
            v-for="(bread, index) in breadcrumb"
            :key="bread.router"
            class="breadcrumb-container d-flex align-items-center"
          >
            <span
              class="bread-title font-weight-bold"
              :class="{clickable: bread.enable}"
              :style="
                index + 1 === breadcrumb.length
                  ? 'color: #303133; pointer-events: none'
                  : 'color: #606266'
              "
              @click="onClickBread(bread)"
              >{{ $t(bread.name) }}</span
            >
            <i
              v-if="index + 1 !== breadcrumb.length"
              class="icon-Chevron-right"
            >
            </i>
          </div>
        </template>
      </template>

      <span v-else class="bread-title"> {{ $t(title) }} </span>
    </h4>

    <a
      v-if="
        (rightText || rightIcon) && (mode === 'secondary' || mode === 'light')
      "
      href="#"
      class="btn-right text-32 position-absolute h-100 d-block text-white d-flex align-items-center justify-content-center"
      @click.prevent="onClickRight"
    >
      <div
        v-if="rightText"
        id="right-text"
        class="right-text text-16 font-weight-bold"
      >
        {{ $t(rightText) }}
      </div>
      <i v-else class="right-icon" :class="`icon-${rightIcon}`"></i>
      <div
        id="locate-point"
        class="locate-point position-absolute text-12"
        style="right: 30px; opacity: 0"
      >
        -
      </div>
      <b-popover
        v-if="
          $device.isMobile &&
          canShowPopover &&
          ($route.name === 'verificationList' || $route.name === 'verification')
        "
        triggers="click"
        target="locate-point"
        placement="bottom"
        custom-class="hjj-popover base-header-scores-popover"
        container="main"
        :show="hasNewScore"
        >{{ $t('你有新的成績') }}
        <i class="icon-X text-16 ml-2" @click="onClick2ClosePop"></i>
      </b-popover>
    </a>
    <div
      v-if="mode === 'primary'"
      class="d-flex align-items-center"
      style="gap: 16px"
    >
      <Badge>
        <ButtonIcon
          variant="light"
          class="text-primary"
          icon="VIP"
          :size="50"
          :font-size="30"
          style="box-shadow: 0px 4px 20px 0px rgba(199, 199, 199, 0.25)"
          @click="goVIP"
        />
      </Badge>
      <Badge :active="hasUnreadNotifications">
        <ButtonIcon
          variant="light"
          icon="Bell"
          :size="50"
          :font-size="30"
          style="box-shadow: 0px 4px 20px 0px rgba(199, 199, 199, 0.25)"
          @click="goNotification"
        />
      </Badge>

      <div class="avatar-wrap">
        <b-dropdown
          ref="dropdown"
          right
          size="sm"
          variant="link"
          no-caret
          style="position: relative; border-radius: 10px"
          @hidden="avatarDropdownShow = false"
          @shown="avatarDropdownShow = true"
        >
          <template #button-content>
            <div class="avatar-wrapper" style="position: relative">
              <img class="img-fluid w-100 rounded-circle" :srcset="avatarUrl" />
              <!-- <div v-if="hasUnreadNotifications" class="red-dot"></div> -->
            </div>
          </template>
          <div class="personal-menu-wrapper hidden-scroll-all" style="">
            <div class="personal-menu-header">
              <h3>{{ $t('個人') }}</h3>
              <b-button size="oval-sm" @click="logout">
                <i class="icon-Exit" />
              </b-button>
            </div>
            <PersonalMenu
              :is-desktop="true"
              @openAiChat="$refs.dropdown.hide(true)"
            />
          </div>
        </b-dropdown>
      </div>
    </div>
  </b-navbar>
</template>

<script>
import LogoImg from '@/assets/img/logo.png';
import Badge from '@/components/Base/Badge';
import ButtonIcon from '@/components/Base/ButtonIcon';
import goPageMixin from '@/mixin/goPage';
import getAvatarUrl from '@/lib/base/avatarUrl.js';

export default {
  mixins: [goPageMixin],
  props: {
    mode: {
      type: String,
      default: 'secondary',
    },
    title: {
      type: String,
      default: '',
    },
    breadcrumb: {
      type: Array,
      default() {
        return [];
      },
    },
    isTitleBold: {
      type: Boolean,
      default: false,
    },
    leftArrow: {
      type: Boolean,
      default: false,
    },
    leftText: {
      type: String,
      default: '',
    },
    backOnClickLeft: {
      type: Boolean,
      default: true,
    },
    rightIcon: {
      type: String,
      default: '',
    },
    leftIcon: {
      type: String,
      default: '',
    },
    rightText: {
      type: String,
      default: '',
    },
    hasLogo: {
      type: Boolean,
      default: false,
    },
    hasRedDot: {
      type: Boolean,
      default: false,
    },
    scrollMove: {
      type: Boolean,
      default: false,
    },
    scrollContainer: {
      type: String,
      default: '', // CSS selector for scroll container
    },
  },
  components: {
    PersonalMenu: () => import('@/views/Personal/PersonalMenu.vue'),
    Badge,
    ButtonIcon,
  },
  data() {
    return {
      LogoImg,
      avatarDropdownShow: false,
      canShowPopover: true,
      isHeaderVisible: true,
      lastScrollTop: 0,
      scrollElement: null,
    };
  },
  watch: {
    '$route.name': {
      handler() {
        this.canShowPopover = false;
        setTimeout(() => {
          this.canShowPopover = true;
        }, 1000);
      },
      immediate: true,
    },
  },
  computed: {
    isBeta() {
      return this.$store.getters['env/isBeta'];
    },
    isLogin() {
      return this.$store.getters['user/isLogin'];
    },
    userData() {
      return this.$store.getters['user/userData'];
    },
    avatarUrl() {
      return getAvatarUrl(this.userData.avatar);
    },
    hasNewScore() {
      return this.$store.getters['verification/hasNewScore'];
    },
    hasUnreadNotifications() {
      return this.$store.getters['notification/hasUnread'];
    },
    currentPlan() {
      return this.$store.getters['course/currentPlan'];
    },
    navbarClasses() {
      let baseClasses = '';
      switch (this.mode) {
        case 'primary':
          baseClasses = 'primary-header justify-content-between text-dark';
          break;
        case 'secondary':
          baseClasses = 'secondary-header justify-content-center text-white';
          break;
        case 'light':
          baseClasses = 'light-header justify-content-center text-white';
          break;
        default:
          baseClasses = 'secondary-header justify-content-center text-white';
      }

      if (this.scrollMove) {
        baseClasses += ' position-relative';
      }

      return baseClasses;
    },
  },
  methods: {
    toggleAvatar() {
      this.avatarDropdownShow = !this.avatarDropdownShow;
    },
    onClickBread(bread) {
      if (bread.onClick) return bread.onClick();
      this.$router.push({
        name: bread.router,
        query: bread.query,
        params: bread.params,
      });
    },
    onClickLeft() {
      if (this.backOnClickLeft) {
        return this.$router.back();
      }
      return this.$emit('on-click-left');
    },
    onClickRight() {
      return this.$emit('on-click-right');
    },
    onClickOption(action) {
      switch (action) {
        case 'personal':
          return this.$router.push({name: 'personal'});
        case 'setting':
          return this.$router.push({name: 'setting'});
        case 'password':
          return this.$router.push({name: 'password'});
        case 'language':
          return this.$router.push({name: 'language'});
        case 'contact':
          this.$router.push({name: 'contact'});
          break;
        case 'logout':
          return this.logout();
        case 'notifications':
          return this.$router.push({name: 'notification'});
        default:
          break;
      }
    },
    onClick2ClosePop() {
      this.$emit('on-click-close-pop');
    },
    async logout() {
      await this.$store.dispatch('user/logout');
      this.$JPush.updateTags();
    },
    showHeader() {
      if (this.autoHide) {
        this.isHeaderVisible = true;
      }
    },
    hideHeader() {
      if (this.autoHide) {
        this.isHeaderVisible = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.base-header {
  min-height: 56px;
  background: $secondary;
  animation: delayShow 0.2s forwards;
  padding: 0;
  @media screen and (min-width: 768px) {
    animation: none;
  }
  .btn-left {
    top: 0;
    left: 0;
    text-decoration: none;
    opacity: 0;
    animation: delayShow 0.2s forwards;
    @media screen and (min-width: 768px) {
      opacity: 1;
      animation: none;
    }
    .left-icon {
      padding: 6px 6px 6px 12px;
    }
    .red-dot {
      width: 14px;
      height: 14px;
      top: 12px;
      right: 6px;
      border-radius: 50%;
      z-index: 5;
    }
    .left-text {
      padding-left: 16px;
      @media screen and (min-width: 768px) {
        background: $accent;
        padding: 5px 12px;
        margin-left: 16px;
        border-radius: $rounded-sm;
        line-height: 28px;
      }
    }
  }
  .breadcrumb-container {
    margin-right: 8px;

    .bread-title {
      font-size: 20px;
      margin-right: 8px;
      color: #606266;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &.clickable {
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    i {
      font-size: 32px;
      color: rgba(144, 147, 153, 1);
    }
  }
  .breadcrumb-ellipsis-dropdown {
    :deep(.btn) {
      padding: 0;
      color: #606266 !important;
      font-weight: bold;
      font-size: 20px;
      text-decoration: none !important;
      line-height: 1;
      vertical-align: middle;
      margin-right: 8px;
      &:focus {
        box-shadow: none;
      }
      &:hover {
        text-decoration: underline !important;
      }
    }
    :deep(.dropdown-menu) {
      width: auto;
      min-width: 120px;
      max-width: 300px;
    }
  }
  .base-header-title {
    opacity: 0;
    animation: delayShow 0.2s forwards;
    @media screen and (min-width: 768px) {
      opacity: 1;
      animation: none;
    }
  }
  .btn-right {
    right: 0;
    text-decoration: none;
    .right-icon {
      padding: 6px 12px 6px 6px;
      @media screen and (min-width: 768px) {
        background: $accent;
        padding: 5px 12px;
        margin-right: 8px;
        border-radius: $rounded-sm;
        line-height: 28px;
      }
    }
    .right-text {
      padding-right: 16px;
    }
  }
  .avatar-wrap {
    width: 40px;
    height: 40px;
    :deep(.btn) {
      padding: 0;
    }
  }
  .notification-wrap {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    .icon-Bell {
      font-size: 30px;
    }
    .notification-dot {
      width: 14px;
      height: 14px;
      border-radius: 50%;
      top: 0;
      right: 0;
    }
  }
  &.primary-header {
    background: $bgcontainer;
    padding: 0 32px;
    min-height: 80px;
    border-bottom: 1px solid $line-2;
  }
  &.light-header {
    background: $white;

    &.text-white,
    .text-white {
      color: var(--Text-Primary, #303133) !important;
    }

    .base-header-title {
      max-width: calc(100% - 96px);
      .bread-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  // 自動隱藏功能樣式
  &.auto-hide-header {
    transition: all 0.3s ease-out;

    &.header-hidden {
      transform: translateY(-100%);
    }
  }
}
:deep(.dropdown-menu) {
  max-width: 224px;
  width: 224px;
  z-index: 1050;
}
:deep().dropdown-item {
  height: 36px;
  &:hover,
  &:focus,
  &:active {
    background: $grayscale-5;
    color: $font-normal;
  }
}

@keyframes delayShow {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.img-logo {
  width: 151px;
  height: 56px;
}
.ai-tutor {
  .ai-tutor-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
  }
}

.avatar-wrap {
  .red-dot {
    position: absolute;
    top: 0;
    right: 0;
    width: 14px;
    height: 14px;
    background-color: $accent;
    border-radius: 100%;
  }
}

.personal-menu-wrapper {
  width: 350px;
  position: absolute;
  right: -8px;
  top: -2px;
  background: white;
  border-radius: 20px;
  box-shadow: 0px 0px 20px 0px #0000001c;
  max-height: 70vh;
  max-height: calc(100vh - 92px);
  max-height: calc(
    100vh - 92px - env(safe-area-inset-top) - env(safe-area-inset-bottom)
  );
  max-height: calc(
    100dvh - 92px - env(safe-area-inset-top) - env(safe-area-inset-bottom)
  );
  overflow-y: auto;
  padding: 6px;
  .personal-menu-header {
    display: flex;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    .btn {
      padding: 4px;
    }
  }
}

.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1045;
}
</style>
